import { jsx as _jsx } from "react/jsx-runtime";
import { composeInjections, materialProgramInputs } from '../materialProgramInputs';
import { FadedMaterials } from './FadedMaterials';
import { bindHeightmap } from './godotParallax';
import { withPointDraw } from './godotPoint';
import { bindLightmap, LIGHTMAP_PROGRAM, readsLightmap } from '../lightmap/lightmapProgram';
import { useLightmapAssignment } from '../lightmap/useLightmapAssignment';
export function StandardMaterialSlot({ bags, attach, draws = {} }) {
    const lightmap = useLightmapAssignment();
    return (_jsx(FadedMaterials, { attach: attach, children: (pass, mount) => materialBagElement(drawnBag(bags[pass], draws), mount, pass === 'unfaded' ? lightmap : null) }));
}
/** `bag` as a material for the surface `draws` describes. */
export function drawnBag(bag, { pointDraw, particles }) {
    const drawn = withPointDraw(bag, pointDraw);
    return particles ? particles.program(drawn, particles.draw) : drawn;
}
/**
 * A derived bag as its class's JSX tag, reading `lightmap` where it reads one. The missing-texture
 * placeholder mounts through it too.
 */
export function materialBagElement(bag, attach, lightmap) {
    const heightmapTexture = bag.heightmapTexture ?? null;
    const readLightmap = lightmap && readsLightmap(bag.materialClass !== 'basic', bag.props.transparent === true)
        ? lightmap
        : null;
    // A ref, not a prop: three's classes have no heightmap or lightmap field, and a rebind needs no
    // remount.
    const binds = (material) => {
        if (!material)
            return;
        bindHeightmap(material, heightmapTexture);
        bindLightmap(material, readLightmap);
    };
    const injection = composeInjections([bag.injection, readLightmap ? LIGHTMAP_PROGRAM : undefined]);
    // `attach` and the ref first: they are the mount's own props and must never shadow a derived
    // one. The key comes from the same merged bag it travels with (ADR-0038): a program input
    // arriving late, or a moved `attach`, reaches three only through a remount.
    const program = materialProgramInputs({ props: { attach, ref: binds, ...bag.props, injection } });
    switch (bag.materialClass) {
        case 'basic':
            return _jsx("meshBasicMaterial", { ...program.props }, program.key);
        case 'physical':
            return _jsx("meshPhysicalMaterial", { ...program.props }, program.key);
        default:
            return _jsx("meshStandardMaterial", { ...program.props }, program.key);
    }
}
//# sourceMappingURL=StandardMaterialSlot.js.map